import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Input from '../Input';
const parseNumberInput = (maxLength, s) => {
    const onlyNumbers = (s || '').trim().slice(0, maxLength).match(/\d/g);
    return onlyNumbers ? onlyNumbers.join('') : '';
};
const BankAccountInput = (props) => {
    const [shiftRight, setShiftRight] = useState(false);
    const [shiftLeft, setShiftLeft] = useState(false);
    const lang = useSelector((s) => s.lang.economy);
    const regRef = useRef(null);
    const accountRef = useRef(null);
    useEffect(() => {
        if (shiftRight && accountRef.current) {
            accountRef.current.focus();
            setShiftRight(false);
        }
        if (shiftLeft && regRef.current) {
            regRef.current.focus();
            setShiftLeft(false);
        }
    });
    const onRegNumberChange = (e) => {
        const reg = parseNumberInput(4, e.target.value);
        const account = e.target.value.replace('-', '').slice(4).trim().slice(0, 10);
        props.onChange([reg, account.length > 0 ? account : props.value[1]]);
        if (e.target.value.length >= 4) {
            setShiftRight(true);
        }
    };
    const onAccountNumberChange = (e) => {
        props.onChange([props.value[0], parseNumberInput(10, e.target.value)]);
    };
    const onKeyDown = (e) => {
        if (e.key === 'Backspace' &&
            e.target.value.length === 0) {
            setShiftLeft(true);
        }
    };
    return (React.createElement(Wrapper, { className: props.className },
        React.createElement(Input, { style: { width: '6em' }, placeholder: lang.regNumber, onChange: onRegNumberChange, inputRef: regRef, value: props.value[0] }),
        React.createElement("span", { style: { margin: '0em .5em 20px .5em' } }, "-"),
        React.createElement(Input, { placeholder: lang.accountNumber, inputRef: accountRef, onChange: onAccountNumberChange, onKeyDown: onKeyDown, value: props.value[1] })));
};
const Wrapper = styled.div `
  display: flex;
  align-items: center;
`;
export default BankAccountInput;
//# sourceMappingURL=BankAccountInput.js.map